import { Pipe, PipeTransform } from '@angular/core';
import { Referrer } from '../../classes/referrer';

@Pipe({
    name: 'referrerEmailFilter',
    pure: false
})
export class ReferrerEmailFilterPipe implements PipeTransform {
    transform(referrerList: Array<Referrer>, filterValue: string): any {
        if (!referrerList || !filterValue) {
            return referrerList;
        }
        const normalizedFilterValue = filterValue.toLowerCase().trim();
        return referrerList.filter(referrer =>
            (referrer.Email || '').toLowerCase().indexOf(normalizedFilterValue) !== -1
        );
    }
}
